import apiClient from '@/api/apiClient';
import { applyAccountLocale } from '@/i18n';

// When the app opens with somebody logged in, their language (kept in their account) has to be known before anything
// is shown, or the page would appear in the browser's language and then jump. A failure just leaves the browser's language.
export async function loadAccountLocale() {
    const userId = localStorage.getItem('userId');
    if (!userId || !localStorage.getItem('jwt')) {
        return;
    }

    try {
        const response = await apiClient.get('/get-user-details.php', { params: { userId }, timeout: 3000 });
        applyAccountLocale(response.data && response.data.locale);
    } catch (error) {
        // the browser's language stays; the interceptor already handles an expired session
    }
}
